import React, { useState } from 'react'
import './Register.css'
import showPass from '../../../Assests/images/eye-open.jpg'
import hidePass from '../../../Assests/images/eye-closed.png'
import Popup from '../../Popup/Popup'
import { useNavigate } from 'react-router-dom'

const Registration = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfPass, setShowConfPass] = useState(false);
    const [popup, setPopup] = useState({ show: false, message: "", type: "" });

    const [registerDetails, setRegisterDetails] = useState({
        fullName: "",
        role: "",
        email: "",
        password: "",
        confpass: ""
    });

    const navigate =  useNavigate();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setRegisterDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value
        }));
    };

    const submitRegForm = () => {
        const payload = registerDetails;
        fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/registration`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        })
            .then((res) => {
                if (!res.ok) throw new Error("Failed to submit application");
                return res.json();
            })
            .then(() => {
                setPopup({
                    show: true,
                    message: "Application submitted successfully!",
                    type: "success",
                });
                navigate("/applicationFormData")
            })
            .catch(() => {
                setPopup({
                    show: true,
                    message: "Something went wrong. Please try again.",
                    type: "error",
                });
            });
    }

    const togglePassword = () => {
        setShowPassword((prev) => !prev);

    };

    const toggleConfPass = () => {
        setShowConfPass((prev) => !prev);
    };

    console.log("registerDetails", registerDetails)
    return (
        <div className='registrationMain'>
            <div className="registrationSub">
                <h2>Create User</h2>
                <div className="registerFrom">
                    <div className="formInput">
                        <label>
                            Full Name <span className="requiredStar">*</span>
                        </label>
                        <input
                            type="text"
                            name="fullName"
                            placeholder='Enter Name'
                            value={registerDetails.fullName}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="formInput inputFourWidth">
                        <label>Select Role <span className="requiredStar">*</span></label>
                        <select name="role" value={registerDetails.role} onChange={handleChange}>
                            <option value="">-- Select --</option>
                            <option value="Admin">Admin</option>
                            <option value="Manager">Manager</option>
                        </select>

                    </div>

                    <div className="formInput">
                        <label>
                            Email <span className="requiredStar">*</span>
                        </label>
                        <input
                            type="text"
                            name="email"
                            placeholder='Enter Email'
                            value={registerDetails.email}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="formInput" style={{ position: "relative" }}>
                        <label>
                            Password<span className="requiredStar">*</span>
                        </label>
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder='Enter Password'
                            value={registerDetails.password}
                            onChange={handleChange}
                        />
                        <button onClick={togglePassword} className='passWordEye'><img
                            src={showPassword ? showPass : hidePass}
                            alt="Toggle visibility" />
                        </button>
                    </div>

                    <div className="formInput" style={{ position: "relative" }}>
                        <label>
                            Confirm Password<span className="requiredStar">*</span>
                        </label>
                        <input
                            type={showConfPass ? "text" : "password"}
                            name="confpass"
                            placeholder='Enter Password'
                            value={registerDetails.confpass}
                            onChange={handleChange}
                        />
                        <button onClick={toggleConfPass} className='passWordEye'><img
                            src={showConfPass ? showPass : hidePass}
                            alt="Toggle visibility" />
                        </button>
                    </div>

                    <div className="" style={{ textAlign: "center", marginTop: "10px" }}>
                        <button className='submitFormBtn' onClick={submitRegForm}>Submit</button>
                    </div>
                </div>




            </div>
              {popup.show && (
                    <Popup
                      message={popup.message}
                      type={popup.type}
                      onClose={() => setPopup({ show: false, message: "", type: "" })}
                    />
                  )}
        </div>
    )
}

export default Registration